import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef } from "react";
import useSimulatorsNewProduct from "../../hooks/useSimulatorsNewProduct";
import { SearchAdd } from "~misc/icons";
import ModalInfoForSimulation from "../modals/ModalInfoForSimulation";
import ModalDescontoSimuladoNaoAprovado from "../modals/ModalDescontoSimuladoNaoAprovado";
import ValidateFormModal from "~components/Modal/ValidateFormModal";
import { useParams } from "react-router-dom";

const TopoAreaSimulacao = ({ simulador, cliente, values, setValues }) => {
  const {
    initialValues,
    isOpenInfoForSimulation,
    onOpenInfoForSimulation,
    onCloseInfoForSimulation,
    validationInfoForSimulation,
    initialInfoForSimulation,
  } = useSimulatorsNewProduct();

  const formikRef = useRef();
  const { parameter: idCliente, simulacaoId } = useParams();

  const { changeFracionamentoDescargaManual, simulacao } = simulador;

  function onClick(name) {
    changeFracionamentoDescargaManual(name);
  }

  const checkFracionamentoDescargaManual = ({name = "fracionamento"}) => {
    if(simulador?.simulacao){
      return simulador.simulacao.gruposProduto?.map(gp => {
        return gp.produtos.find(e => {
          return e[name] && e[name] !== 0
        })
      }).filter(e => e);
    }
  }

  useEffect(() => {
    formikRef?.current.setFieldValue('fracionamento', simulacao.fracionamento);
    formikRef?.current.setFieldValue('descargaManual', simulacao.descargaManual);
    setValues({
      fracionario: simulacao?.fracionamento || null,
      descarga: simulacao?.descargaManual || null,
    });
  }, [simulacao])

  return (
    <>
      <Formik
      innerRef={formikRef}
        initialValues={initialValues}
      >
        {() => (
          <>
            <Form className="mt-12">
              <div className="grid gap-x-4 md:grid-cols-2 mb-6">
                <div className="grid gap-x-4 grid-cols-2">
                  {
                    checkFracionamentoDescargaManual({})?.length > 0 && (
                      <label className="flex items-center space-x-3 md:justify-center mb-4 md:mb-0">
                        <Field
                          type="checkbox"
                          name="fracionamento"
                          onClick={() => onClick('fracionamento')}
                          className="h-7 w-7 rounded-lg text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 checked:bg-yellow-400 checked:border-transparent checked:text-blue-500 accent-terciaria"
                        />
                        <span className="text-[1.1rem] font-bold md:max-w-[200px] sm:max-w-[100%]">
                          Incluir Valor de Fracionamento
                        </span>
                      </label>
                    )
                  }

                  {
                    checkFracionamentoDescargaManual({name: "descargaManual"})?.length > 0 && (
                      <label className="flex items-center space-x-3 md:justify-center mb-4 md:mb-0">
                        <Field
                          type="checkbox"
                          name="descargaManual"
                          onClick={() => onClick('descargaManual')}
                          className="h-7 w-7 rounded-lg text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 checked:bg-yellow-400 checked:border-transparent checked:text-blue-500 accent-terciaria"
                        />
                        <span className="text-[1.1rem] font-bold md:max-w-[200px] sm:max-w-[100%]">
                          Incluir Valor de Descarga Manual
                        </span>
                      </label>
                    )
                  }
                </div>

                <div>
                  <button
                    type="button"
                    onClick={onOpenInfoForSimulation}
                    className="button-search flex justify-center items-center py-5 px-10 bg-primaria text-white rounded-lg gap-1 font-bold text-lg w-[100%] "
                  >
                    Adicionar Produto
                    <SearchAdd />
                  </button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
      <ModalInfoForSimulation
        isOpen={isOpenInfoForSimulation}
        onClose={onCloseInfoForSimulation}
        validation={validationInfoForSimulation}
        initial={initialInfoForSimulation}
        cliente={cliente}
      />
    </>
  );
};

export default TopoAreaSimulacao;
